'use client';

import { useIsMobile } from '@/hooks/use-mobile';
import { useEffect } from 'react';

const FirefoxMobileDetector = () => {
  const isMobile = useIsMobile();
  useEffect(() => {
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
    const isAndroid = /Android/i.test(ua);
    const isFirefox = /Firefox/i.test(ua);

    if (isAndroid && isFirefox && isMobile) {
      document.documentElement.classList.add('ff-android');
    }
  }, [isMobile]);

  return null;
};

export default FirefoxMobileDetector;
